'use client'

import { useState, useEffect } from 'react'

interface User {
  name: string
  avatar: string
}

export function useUser() {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Load user data from localStorage
    const savedUser = localStorage.getItem('animeTineUser')
    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser)
        setUser(parsedUser)
      } catch (error) {
        console.error('Error parsing saved user data:', error)
        localStorage.removeItem('animeTineUser')
      }
    }
    setLoading(false)
  }, [])

  const saveUser = (userData: User) => {
    setUser(userData)
    localStorage.setItem('animeTineUser', JSON.stringify(userData))
  }

  const clearUser = () => {
    setUser(null)
    localStorage.removeItem('animeTineUser')
    // Force page reload to ensure clean state
    window.location.reload()
  }

  // Add reset function to window for testing
  useEffect(() => {
    if (typeof window !== 'undefined') {
      (window as any).resetAnimeTineUser = clearUser
    }
  }, [])

  return {
    user,
    loading,
    saveUser,
    clearUser,
    isLoggedIn: !!user
  }
}
